export const prefixRoute = (route = '') => {
  const prefix = '/api/ui';

  return `${prefix}/${route}`;
};
